import {createContext} from 'react';

const themeContext = createContext({
    darkTheme: true,
    setDarkTheme: () => {}
});

export default themeContext;
